export const clients = ({ token }) => ({
  HTTPMethod: "get",
  path: `/clients`,
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  body: {},
});
